import instances from '../../List/instances';
/**
 *
 * @param {import('data/types').DataListWhereClause} listIdentifier An object used to
 * identify grids currently on page and run batch operations like refresh
 */

var dataListActions = function dataListActions(where) {
  return {
    /**
     * Fetches data from the server and refreshes the list.
     * */
    refresh: function refresh(options) {
      return instances.refresh(where, options);
    }
  };
};

export default dataListActions;